//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Work, Author } from "@/models";
import SearchBox from "@/components/SearchBox.vue";
import WorkItem from "@/components/WorkItem.vue";
import AuthorItem from "@/components/AuthorItem.vue";
import { clearTimeout, setTimeout } from "timers";

export default {
  name: "Search",
  created() {
    this.keyword = this.$route.query.q || "";

    this.search();
  },
  props: [],
  data() {
    return {
      keyword: "",
      works: [],
      authors: [],
      timer: null
    };
  },
  metaInfo() {
    return {
      title: "搜索"
    };
  },
  methods: {
    search: function() {
      let keyword = (this.keyword || "").trim();

      if (keyword == "") {
        this.works = [];
        this.authors = [];
        return;
      }

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        Promise.all([
          Work.search(this.keyword),
          Author.search(this.keyword)
        ]).then(([works, authors]) => {
          this.works = works;
          this.authors = authors;
          this.timer = null;
        });
      }, 500);
    }
  },
  components: {
    SearchBox,
    WorkItem,
    AuthorItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/Search.vue